export class IntroducerController {
  firstTime: boolean = false;

  static $inject = ["$routeParams", "$rootScope", "$location"];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
  ) {
    if (this.$routeParams.status === "new") {
      this.firstTime = true;
    }
  }

  continueToLogin() {
    (this.$rootScope as any) = null;
    this.go("/login");
  }

  go(path): void {
    this.$location.path(path);
  }
}
